import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import AuthCallback from "@/components/AuthCallback";

import Home from "@/pages/Home";
import About from "@/pages/About";
import WhatIsIt from "@/pages/WhatIsIt";
import HowItWorks from "@/pages/HowItWorks";
import FAQ from "@/pages/FAQ";
import { Services, ServiceDetail } from "@/pages/Services";
import { Workshops, WorkshopDetail } from "@/pages/Workshops";
import Testimonials from "@/pages/Testimonials";
import { Resources, ResourceDetail } from "@/pages/Resources";
import Contact from "@/pages/Contact";
import Book from "@/pages/Book";
import { Privacy, Terms, Disclaimer, NotFound } from "@/pages/Legal";
import Admin from "@/pages/admin/Admin";

const withLayout = (el) => <Layout>{el}</Layout>;

function AppRouter() {
  const location = useLocation();
  // Handle OAuth callback: process session_id BEFORE any protected route runs.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={withLayout(<Home />)} />
      <Route path="/about" element={withLayout(<About />)} />
      <Route path="/what-is-family-constellation" element={withLayout(<WhatIsIt />)} />
      <Route path="/how-it-works" element={withLayout(<HowItWorks />)} />
      <Route path="/faq" element={withLayout(<FAQ />)} />
      <Route path="/services" element={withLayout(<Services />)} />
      <Route path="/services/:slug" element={withLayout(<ServiceDetail />)} />
      <Route path="/workshops" element={withLayout(<Workshops />)} />
      <Route path="/workshops/:slug" element={withLayout(<WorkshopDetail />)} />
      <Route path="/testimonials" element={withLayout(<Testimonials />)} />
      <Route path="/resources" element={withLayout(<Resources />)} />
      <Route path="/resources/:slug" element={withLayout(<ResourceDetail />)} />
      <Route path="/contact" element={withLayout(<Contact />)} />
      <Route path="/book" element={withLayout(<Book />)} />
      <Route path="/privacy-policy" element={withLayout(<Privacy />)} />
      <Route path="/terms" element={withLayout(<Terms />)} />
      <Route path="/disclaimer" element={withLayout(<Disclaimer />)} />
      <Route path="/admin" element={<Admin />} />
      <Route path="*" element={withLayout(<NotFound />)} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-center" richColors />
        <AppRouter />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
